import React, { useState } from "react";

import { Stack } from "@mui/material";

import { NewsComment } from "./types";
import { CommentHeader } from "./CommentHeader";
import { CommentText } from "./CommentText";
import { ReplyButton } from "./ReplyButton";
import { ReplyInput } from "./ReplyInput";

interface Props {
  comment: NewsComment;
  childComments: NewsComment[];
  onReply?: (commentId: string, text: string) => void;
  isReply?: boolean;
  getChildren: (parentId: string) => NewsComment[];
  currentUserAvatarUrl?: string;
}

export const CommentItem: React.FC<Props> = ({
  comment,
  childComments,
  onReply,
  isReply = false,
  getChildren,
  currentUserAvatarUrl
}) => {
  const [isReplying, setIsReplying] = useState(false);

  const handleReplyClick = () => {
    setIsReplying(true);
  };

  const handleSendReply = (text: string) => {
    if (onReply) {
      onReply(comment.id, text);
      setIsReplying(false);
    }
  };

  const handleCancelReply = () => {
    setIsReplying(false);
  };

  return (
    <Stack
      sx={{
        gap: "10px",
        pl: isReply ? "50px" : 0
      }}
    >
      <CommentHeader comment={comment} />
      <CommentText text={comment.text} />
      {!isReplying && onReply && <ReplyButton onReply={handleReplyClick} />}
      {isReplying && (
        <ReplyInput
          currentUserAvatarUrl={currentUserAvatarUrl}
          onSend={handleSendReply}
          onCancel={handleCancelReply}
        />
      )}
      {childComments.map((reply) => (
        <CommentItem
          key={reply.id}
          comment={reply}
          childComments={getChildren(reply.id)}
          onReply={onReply}
          isReply={true}
          getChildren={getChildren}
          currentUserAvatarUrl={currentUserAvatarUrl}
        />
      ))}
    </Stack>
  );
};

